<template>
  <ion-app>
    <loading v-model:active="isLoading" :is-full-page="true"/>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent,provide,ref } from 'vue';
import store from "@/store";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import api from '@/api/api.js';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    Loading
  },
  setup(){
    let isLoading = ref(true);
    provide("mapStore", store);
    api.apiGetDuty().then(()=>{ 
      isLoading.value = false;
    });
    return {
      isLoading
    }
  }
});
</script>
<style>
ion-card{
  border-radius: 20px;
}
</style>